export default __webpack_public_path__ + "static/media/G02CCI.239a3593.jpg";